import {FC} from 'react';
import {Box, Typography} from '@mui/material';
import {useIntl} from 'react-intl';
import {getToolLabelId} from '../utils/toolLabels';
import {toolCallSx} from './ToolCallIndicator.sx';

interface ToolCallIndicatorProps {
    toolName?: string | null;
}

export const ToolCallIndicator: FC<ToolCallIndicatorProps> = ({toolName}) => {
    const intl = useIntl();

    const labelId = toolName ? getToolLabelId(toolName) : 'aiAgentThinking';

    // Silent/internal tool — don't render
    if (labelId === null) return null;

    const label = intl.formatMessage({id: labelId});

    return (
        <Box sx={toolCallSx.root}>
            <Box sx={toolCallSx.dots}>
                <span />
                <span />
                <span />
            </Box>
            <Typography sx={toolCallSx.text}>{label}</Typography>
        </Box>
    );
};
